import React from "react";
import "./publications.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Publications = () => {
  return (
    <div className="publications" id="publications">
      <h1> Research Papers</h1>
      <hr></hr>

      <div className="row">
        <div className="col-md-6 paper">
          <h3>
            <a
              href="https://ieeexplore.ieee.org/abstract/document/10195092"
              title="Paper Link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Roy, K., Garg, T., Palit, V., Zi, Y., Narayanan, V., & Sheth, A.
              (2023). Knowledge Graph Guided Semantic Evaluation of Language
              Models For User Trust. 2023 IEEE Conference on Artificial Intelligence (CAI)
            </a>
          </h3>
          <p style={{fontSize: "0.95rem", color: "#666", marginTop: "10px"}}>
            Explored knowledge graph-based approaches to evaluate and enhance semantic understanding and trustworthiness of large language models. Published in IEEE CAI 2023.
          </p>
        </div>
        <div className="col-md-6 paper">
          <h3>
            <a
              href="https://www.sciencedirect.com/science/article/abs/pii/S2352710221011141"
              title="Paper Link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Rao, V. V., Garg, T., & Datta, S. P. (2021). Predictive Assessment from ANN and MLR Models to Optimize the Ideal Evaporative/Hybrid Cooler. Journal of Building Engineering
            </a>
          </h3>
          <p style={{fontSize: "0.95rem", color: "#666", marginTop: "10px"}}>
            Developed predictive models using Artificial Neural Networks and Multiple Linear Regression to optimize cooling system performance. Published in Journal of Building Engineering.
          </p>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

export default Publications;
